import Hubspot from '../../services/Hubspot';

export default {
    init(instance) {
        document.addEventListener('alpine:init', () => {
            instance.data('businessNameSearchForm', () => ({
                inputs: {
                    email: '',
                    first_name: '',
                    last_name: '',
                    entity_type: '',
                    entity_state: '',
                    request_business_name: '',
                    agree: false,
                },
                errors: {},
                showMessage: false,
                successMessage: true,
                errorMessage: false,

                validateField(fieldName) {
                    delete this.errors[fieldName];

                    switch (fieldName) {
                        case 'first_name':
                            if (!this.inputs.first_name.trim()) {
                                this.errors.first_name = 'Please complete this required field.';
                            } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.first_name)) {
                                this.errors.first_name = 'Must only contain letters, numbers, and spaces.';
                            } else if (this.inputs.first_name.length > 50) {
                                this.errors.first_name = 'Must be less than 50 characters.';
                            }
                            break;

                        case 'last_name':
                            if (!this.inputs.last_name.trim()) {
                                this.errors.last_name = 'Please complete this required field.';
                            } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.last_name)) {
                                this.errors.last_name = 'Must only contain letters, numbers, and spaces.';
                            } else if (this.inputs.last_name.length > 50) {
                                this.errors.last_name = 'Must be less than 50 characters.';
                            }
                            break;

                        case 'email':
                            if (!this.inputs.email.trim()) {
                                this.errors.email = 'Please complete this required field.';
                            } else if (!this.validateEmail(this.inputs.email)) {
                                this.errors.email = 'Email must be formatted correctly.';
                            }
                            break;

                        case 'entity_type':
                            if (!this.inputs.entity_type) {
                                this.errors.entity_type = 'Please complete this required field.';
                            }
                            break;

                        case 'entity_state':
                            if (!this.inputs.entity_state) {
                                this.errors.entity_state = 'Please complete this required field.';
                            }
                            break;

                        case 'request_business_name':
                            if (!this.inputs.request_business_name.trim()) {
                                this.errors.request_business_name = 'Please complete this required field.';
                            } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.request_business_name)) {
                                this.errors.request_business_name = 'Must only contain letters, numbers, and spaces.';
                            } else if (this.inputs.request_business_name.length > 100) {
                                this.errors.request_business_name = 'Must be less than 100 characters.';
                            }
                            break;

                        case 'agree':
                            if (!this.inputs.agree) {
                                this.errors.agree = 'Please complete this required field.';
                            }
                            break;

                        default:
                            break;
                    }
                },

                validateAll() {
                    this.errors = {};

                    Object.keys(this.inputs).forEach((fieldName) => {
                        this.validateField(fieldName);
                    });
                },

                validateEmail(email) {
                    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return re.test(email.toLowerCase());
                },

                async submitForm() {
                    this.validateAll();

                    if (Object.keys(this.errors).length > 0) {
                        return;
                    }

                    const payload = {
                        email: this.inputs.email,
                        first_name: this.inputs.first_name,
                        last_name: this.inputs.last_name,
                        entity_type: this.inputs.entity_type,
                        entity_state: this.inputs.entity_state,
                        request_business_name: this.inputs.request_business_name,
                    };

                    try {
                        const { data } = await Hubspot.checkNameAvailability(payload);
                        if (data.success) {
                            this.showMessage = true;
                            this.successMessage = data.data.inlineMessage;
                            this.errorMessage = false;
                            this.resetForm();
                        } else {
                            console.error('Failed to submit form');
                            this.showMessage = true;
                            this.successMessage = '';
                            this.errorMessage = 'Failed to submit form, try again.';
                        }
                    } catch (error) {
                        console.error('Error:', error);
                        this.showMessage = true;
                        this.successMessage = '';
                        this.errorMessage = 'Failed to submit form, try again.';
                    }
                },

                resetForm() {
                    this.inputs.email = '';
                    this.inputs.first_name = '';
                    this.inputs.last_name = '';
                    this.inputs.entity_type = '';
                    this.inputs.entity_state = '';
                    this.inputs.request_business_name = '';
                    this.inputs.agree = false;
                    this.errors = {};
                    const formWrapper = document.getElementById('form-wrapper');

                    if (formWrapper) {
                        formWrapper.scrollIntoView({ behavior: 'smooth' });
                    }
                },
            }));
        });
    },
};
